"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Modal } from "@/components/ui/modals/Modal";
import type { Labels } from "@/lib/labels/types";
import type { ResolvedListings } from "../utils/resolveMatchListings";
import { AllBroadcastersDialog } from "./AllBroadcastersDialog";
interface Props {
  resolved: ResolvedListings;
  labels: Labels;
  /** Use a compact chevron trigger instead of the full "See all broadcasters" button. */
  compact?: boolean;
  /** Trigger will sit on a primary-color background — use high-contrast styling. */
  onPrimary?: boolean;
}
export function AllBroadcastersModalTrigger(t0) {
  const $ = _c(17);
  const {
    resolved,
    labels,
    compact: t1,
    onPrimary: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const onPrimary = t2 === undefined ? false : t2;
  const [open, setOpen] = useState(false);
  const countries = Object.keys(resolved.byCountry);
  if (countries.length === 0) {
    return null;
  }
  let t3;
  if ($[0] !== compact || $[1] !== onPrimary) {
    t3 = onPrimary ? ["see-all-broadcasters shrink-0 cursor-pointer", "px-3 py-1 text-xs font-medium rounded-full", "bg-white/15 hover:bg-white/25", "[color:var(--color-primary-foreground,white)]", "transition-colors"].join(" ") : compact ? "see-all-broadcasters cursor-pointer px-2 py-0.5 text-xs rounded border [border-color:var(--color-border,theme(colors.gray.300))] opacity-70 hover:opacity-100" : "see-all-broadcasters cursor-pointer px-2.5 py-1 rounded border [border-color:var(--color-border,theme(colors.gray.300))]";
    $[0] = compact;
    $[1] = onPrimary;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const className = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpen(true);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== className || $[5] !== labels.tv.seeAllBroadcasters) {
    t5 = <button type="button" onClick={t4} className={className} aria-label={labels.tv.seeAllBroadcasters}>{labels.tv.seeAllBroadcasters}</button>;
    $[4] = className;
    $[5] = labels.tv.seeAllBroadcasters;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(false);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== labels || $[9] !== resolved) {
    t7 = <AllBroadcastersDialog resolved={resolved} labels={labels} />;
    $[8] = labels;
    $[9] = resolved;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== open || $[12] !== t7) {
    t8 = <Modal isOpen={open} onClose={t6}>{t7}</Modal>;
    $[11] = open;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}